/**
 * BOOTSTRAP PATTERN
 * This is to ensure that the application and JHP are loaded asynchronously
 */
import('./bootstrap')
